import React, { useEffect } from 'react';
import '../../../App.css';
import './Sculc2024.css';
import { useAuth } from '../../../contexts/AuthContext.js';
import { useNavigate } from 'react-router-dom';
import { getFirestoreData } from '../../../firebase/Firestore.js';

import AOS from 'aos';
import 'aos/dist/aos.css';

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import SculcNavbar from '../SculcNavbar.js';

const Sculc2024 = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const sculc2024_images = [
        { original: "/images/sculc2024/2024_Program-1.png" },
        { original: "/images/sculc2024/2024_Program-2.png" },
        { original: "/images/sculc2024/2024_Program-3.png" },
        { original: "/images/sculc2024/2024_Program-4.png" }
    ];

    return (
        <>
        <div className="sculc2024-page">
            <div className="sculc2024-header-container">
                <img
                    src="/images/sculc-banner.jpg"
                    alt="Header"
                    className="sculc2024-header-image"
                />  
                <h1 className="sculc2024-title">SCULC 2024</h1>
            </div>

                <div className="sculc2024-banner">
                    <p style={{ fontSize: "1.5em" }}>SCULC 2024 has concluded!</p>
                    <br />
                    <a href="/sculc-2025" className="sculc2024-link">Check out SCULC 2025</a>
                </div>

                <div className="sculc2024-container">
                    <div className="sculc2024-table-container">
                        <div className="sculc2024-logo-container">
                            <img src="/images/sculc-logo.png" alt="Sculc-logo" className="sculc2024-logos" />
                            <img src="/images/dept-ling.png" alt="dept-of-ling" className="sculc2024-logos" />
                            <img src="/images/bruin-linguists-logo.png" alt="club-logo" className="sculc2024-logos" />
                        </div>
                        <div className="sculc2024-table-cells">
                            <h2 className="sculc2024-subtitle" >Southern California Undergraduate Linguistics Conference</h2>
                            <br />
                            <p style={{ fontSize: "1.3em" }}>Saturday, 18 May 2024, 09:00 AM - 05:00 PM</p>
                            <br />
                            <p style={{ fontSize: "1.3em" }}>UCLA's Campbell Hall Learning Pavilion</p>
                            <br />
                            <p style={{ fontSize: "1.2em", textAlign: "left", lineHeight: "1.5em" }}>
                                <strong>SCULC</strong> (the Southern California Undergraduate Linguistics Conference) will be held again in May 2024 by the UCLA Linguistics Department and the undergraduate-run Bruin Linguists Society.
                                It’s a student-run, collaborative, and educational environment to showcase undergraduate research from across institutions.
                            </p>
                            <br />
                            <p><i>Sponsored by the UCLA Department of Linguistics and the Bruin Linguists Society</i></p>
                            <div style={{ height: "5em" }}></div>
                            <p style={{ fontSize: "1.8em", color: "#2774ae", textAlign:"center" }}>Our Call for Abstracts has closed</p>
                        </div>
                    </div>

                    <div className="sculc2024-table-container">
                        <div className="sculc2024-schedule-container">
                            <ImageGallery items={sculc2024_images} showThumbnails={false} showPlayButton={false} width="100%" />
                        </div>
                        <div className="sculc2024-table-cells" style={{ textAlign: "left", fontSize: "1.2em", flex: "1 1 40%" }}>
                            <p>Please <strong>view our Program</strong> through the Image Carousel on the left or download it from the Program page.</p>
                            <br />
                            <p><u>All conference attendees must fill out the following RSVP form.</u></p>
                            <br />
                            <p><strong>RSVP form: </strong><a href="https://tinyurl.com/sculc2024">https://tinyurl.com/sculc2024</a></p>
                            <br />
                            <p>All attendees must also fill out the UCLA Daily Symptom Monitoring Survey on the day of the event.</p>
                            <br />
                            <p><strong>UCLA COVID-19 Guidelines:</strong></p>
                            <p>Visit <a href="https://covid-19.ucla.edu">https://covid-19.ucla.edu</a> for the most up-to-date policies regarding masking and health protocols.</p>
                        </div>
                    </div>

                    {/* 🎯 NEW: Google Slides Embed */}
                    <div className="sculc2024-table-container" style={{width: "100%"} }>
                        <div
                            className="sculc2024-table-cells"
                            style={{ width: "100%", textAlign: "center", marginTop: "3em" }}
                            data-aos="fade-up"
                            data-aos-once="true"
                        >
                            <p style={{ fontSize: "2em", color: "#2774ae" }}>Conference Program Slides</p>
                            <div className="google-slides-embed">
                                <iframe
                                    src="https://docs.google.com/presentation/d/e/2PACX-1vSQij0yHQ6MhKqD7lxnPxOWkcCHtvbbdhdIX1UbWJoExyyvfaZWyyY8S3tj9ArG3w/pubembed?start=false&loop=false&delayms=3000"
                                    frameBorder="0"
                                    width="720"
                                    height="405"
                                    allowFullScreen
                                    title="SCULC 2024 Slides"
                                ></iframe>
                            </div>
                        </div>
                    </div>

                    <div className="sculc2024-table-container">
                        <div className="sculc2024-table-cells" style={{ width: "100%", textAlign: "left", fontSize: "1.2em", marginTop: "1em" }}>
                            <p style={{ fontSize: "2em", color: "#2774ae" }}>PRESENTERS</p><br />
                            <p>SCULC is looking for undergraduate presenters from any university to submit their research for presentation. All levels welcome, including recent graduates not yet in grad school.</p>
                            <br />
                            <p><strong>Call For Abstracts Link:</strong> <a href="https://easychair.org/cfp/SCULC2024">easychair.org/cfp/SCULC2024</a></p>
                            <br />
                            <p><strong>Abstract Submission Guidelines:</strong></p>
                            <ul>
                                <li>Submit by March 24, 2024 at 11:59 PM PST</li>
                                <li>Max 500 words, not including references</li>
                                <li>PDF format only, anonymized</li>
                                <li>If part of a larger research group, be prepared to verify PI permission if accepted</li>
                            </ul>
                            <p>Questions? Contact <a href="mailto:bruinlinguists@gmail.com">bruinlinguists@gmail.com</a> and mention SCULC 2024 in your subject line.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sculc2024;